module.exports = __webpack_public_path__ + "img/cinnamon.5eb6d272.png";